/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsdSicherheitsbriefDto } from '../../models/asd-sicherheitsbrief-dto';

export interface UploadAsdSicherheitsbrief$Params {

/**
 * name of a document
 */
  fileName?: string;
      body?: {

/**
 * the ASD Sicherheitsbrief to be uploaded
 */
'data': Blob;
}
}

export function uploadAsdSicherheitsbrief(http: HttpClient, rootUrl: string, params?: UploadAsdSicherheitsbrief$Params, context?: HttpContext): Observable<StrictHttpResponse<AsdSicherheitsbriefDto>> {
  const rb = new RequestBuilder(rootUrl, uploadAsdSicherheitsbrief.PATH, 'post');
  if (params) {
    rb.query('fileName', params.fileName, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AsdSicherheitsbriefDto>;
    })
  );
}

uploadAsdSicherheitsbrief.PATH = '/documents/asd-sicherheitsbrief';
